module.exports = "/images/sindh.svg?b1f16b6b5bae1f41aab9cc39c8c48043";